/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connections_Outlook_Connected_TitleInputs */



/**
* | output |
* | --- |
* | "Connected Outlook mailboxes" |
*
* @param {Connections_Outlook_Connected_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const connections_outlook_connected_title = /** @type {((inputs?: Connections_Outlook_Connected_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_Outlook_Connected_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verbundene Outlook-Postfächer")
	return /** @type {LocalizedString} */ ("Connected Outlook mailboxes")
});